<!--Exel Uploder-->
<div class="modal fade" id="exelUploder" tabindex="-1" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header dirI">
                <h5 class="modal-title" id="">ورود ساعت کارکرد خودروها </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body d-flex justify-content-center">
                <input type="file" class="d-none" id="fileupload" accept=".xlsx" (change)="onFileChange($event)">
                <button class="btn btn-success " (click)="browseRequested.emit()">بارگذاری اکسل</button>
            </div>
            <div class="modal-footer dirI">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">بستن </button>
                <button type="button" class="btn btn-primary" (click)="saved.emit()">ذخیره</button>
            </div>
        </div>
    </div>
</div>
